function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomLivingRoomFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 29H1v-2h28v2zM1 17a1 1 0 011-1h4a1 1 0 011 1v3h10v-3a1 1 0 011-1h4a1 1 0 011 1v8a1 1 0 01-1 1H2a1 1 0 01-1-1v-8zm2 1v6h18v-6h-2v3a1 1 0 01-1 1H6a1 1 0 01-1-1v-3H3z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 28v-3h2v3H2zM20 28v-3h2v3h-2zM4 13a1 1 0 011-1h14a1 1 0 011 1v5h-2v-4H6v4H4v-5zM27 9.5V28h-2V9.5h2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.988 5l-.571 3h3.166l-.571-3h-2.024zm3.679-2h-5.334L22 10h8l-1.333-7z",
    fill: props.color
  }));
}

export default SvgIconRoomLivingRoomFilled;